import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const UserIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.38505 10.8217C3.44187 11.3833 0.968909 12.5301 2.47511 13.9651C3.21088 14.666 4.03033 15.1673 5.06058 15.1673H10.9394C11.9697 15.1673 12.7891 14.666 13.5249 13.9651C15.0311 12.5301 12.5581 11.3833 11.6149 10.8217C9.4032 9.50473 6.5968 9.50473 4.38505 10.8217Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 4.83398C11 6.49084 9.65687 7.83398 8 7.83398C6.34315 7.83398 5 6.49084 5 4.83398C5 3.17713 6.34315 1.83398 8 1.83398C9.65687 1.83398 11 3.17713 11 4.83398Z"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);
